import { useEffect, useState } from "react";

const THEME_KEY = "admin:theme";

/**
 * Выбранная тема.
 *
 * Отдельным модулем от `AntdProvider`: файл, экспортирующий и компонент, и
 * хук, ломает fast refresh — Vite перезагружает страницу целиком вместо
 * горячей замены.
 *
 * Умолчание — системная тема, выбор запоминается на устройстве.
 */
function readTheme(): "light" | "dark" {
  try {
    const stored = localStorage.getItem(THEME_KEY);
    if (stored === "light" || stored === "dark") return stored;
  } catch {
    // Storage запрещён политикой браузера — берём системную тему.
  }
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function useThemeMode(): ["light" | "dark", () => void] {
  const [mode, setMode] = useState<"light" | "dark">(readTheme);

  useEffect(() => {
    try {
      localStorage.setItem(THEME_KEY, mode);
    } catch {
      /* см. readTheme */
    }
  }, [mode]);

  return [
    mode,
    () => {
      setMode((current) => (current === "dark" ? "light" : "dark"));
    },
  ];
}
